import { object, string } from "yup";

export const getValidation = () => {
  const validationSchema = object({
    adminFirstName: string()
      .required("First Name can’t be blank.")
      .default(""),
    adminLastName: string()
      .required("Last Name can’t be blank.")
      .default(""),
    adminEmail: string()
      .email("Invalid email.")
      .trim()
      .required("Email can’t be blank.")
      .default(""),
    organizationName: string()
      .required()
      .default(""),
    organizationDescription: string()
      .default(null)
      .nullable(),
    organizationContactEmail: string()
      .email("Invalid email.")
      .trim()
      .nullable()
      .default(null)
  });

  return { validationSchema, defaultValues: validationSchema.cast({}) };
};
